







































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import AppSelector from '@/components/AppSelector.vue'
import { ICarrierInfoInput } from '@/modules/Carrier/interfaces/carrier-form'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppTextarea,
    AppFormCheckbox
  }
})
export default class CarrierFormInfo extends Vue {
  @Prop({ type: Object as () => ICarrierInfoInput }) value!: ICarrierInfoInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
